"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStatusCode = exports.getUnprocessableErrors = exports.isUnprocessableError = exports.isConflictError = exports.isInternalError = void 0;
const isInternalError = (error) => {
    return (0, exports.getStatusCode)(error) >= 500;
};
exports.isInternalError = isInternalError;
const isConflictError = (error) => {
    return (0, exports.getStatusCode)(error) === 409;
};
exports.isConflictError = isConflictError;
const isUnprocessableError = (error) => {
    return (0, exports.getStatusCode)(error) === 422;
};
exports.isUnprocessableError = isUnprocessableError;
const getUnprocessableErrors = (error) => {
    if (!error)
        return [];
    const { graphQLErrors, networkError } = error;
    if (networkError) {
        return [];
    }
    else if (graphQLErrors?.length > 0) {
        const firstError = graphQLErrors[0];
        if (firstError.extensions) {
            const { statusCode, errors = [] } = firstError.extensions;
            if (statusCode === 422) {
                return errors || [];
            }
        }
    }
    return [];
};
exports.getUnprocessableErrors = getUnprocessableErrors;
const getStatusCode = (error) => {
    if (!error)
        return 500;
    const { graphQLErrors, networkError } = error;
    if (networkError) {
        return networkError?.statusCode;
    }
    else if (graphQLErrors && graphQLErrors?.length > 0) {
        const firstError = graphQLErrors[0];
        if (firstError.extensions) {
            const { statusCode } = firstError.extensions;
            return statusCode;
        }
    }
    return 500;
};
exports.getStatusCode = getStatusCode;
//# sourceMappingURL=error.js.map